import { memo } from "react";

const Bank = () => (
  <svg width="32" height="32" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="14" cy="14" r="13.5" stroke="#D5D5D5" />
    <g clipPath="url(#clip0_626_10017)">
      <path
        d="M7.3335 19.333H20.6668V20.6663H7.3335V19.333ZM8.66683 13.9997H10.0002V18.6663H8.66683V13.9997ZM12.0002 13.9997H13.3335V18.6663H12.0002V13.9997ZM14.6668 13.9997H16.0002V18.6663H14.6668V13.9997ZM18.0002 13.9997H19.3335V18.6663H18.0002V13.9997ZM7.3335 10.6663L14.0002 7.33301L20.6668 10.6663V13.333H7.3335V10.6663ZM8.66683 11.4903V11.9997H19.3335V11.4903L14.0002 8.82367L8.66683 11.4903ZM14.0002 11.333C13.8234 11.333 13.6538 11.2628 13.5288 11.1377C13.4037 11.0127 13.3335 10.8432 13.3335 10.6663C13.3335 10.4895 13.4037 10.32 13.5288 10.1949C13.6538 10.0699 13.8234 9.99967 14.0002 9.99967C14.177 9.99967 14.3465 10.0699 14.4716 10.1949C14.5966 10.32 14.6668 10.4895 14.6668 10.6663C14.6668 10.8432 14.5966 11.0127 14.4716 11.1377C14.3465 11.2628 14.177 11.333 14.0002 11.333Z"
        fill="#9F9F9F"
      />
    </g>
    <defs>
      <clipPath id="clip0_626_10017">
        <rect width="16" height="16" fill="white" transform="translate(6 6)" />
      </clipPath>
    </defs>
  </svg>
);

export default memo(Bank);
